'use client';

import '../src/index.css';
import '../design/glas.css';
import '../design/tabelle-karten.css';

import ClientFehlerSeite from '../src/components/fehlerseite/ClientFehlerSeite';
import { GRUNDSTIL } from './_gemeinsam/kopf';

/**
 * Greift, wenn ein Root-Layout selbst wirft — praktisch: Eine Server-Seite
 * (Startseite, Landingpage) erreicht beim Aufbau die Sprach-Matrix des
 * Backends nicht (`localeConfig` in `(seiten)/…/layout.tsx`). Ersetzt das
 * Layout, bringt also `<html>`, `<body>` und das CSS selbst mit.
 *
 * Die Texte kommen aus dem mitgelieferten Auszug (`fehlerseite/texte.ts`),
 * nicht vom Backend — das ist ja gerade nicht erreichbar.
 */
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  return (
    <html lang="de">
      <head>
        <style dangerouslySetInnerHTML={{ __html: GRUNDSTIL }} />
      </head>
      <body>
        <ClientFehlerSeite error={error} />
      </body>
    </html>
  );
}
